import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TxtService } from './txt.service';
import { AsyncPipe } from '@angular/common';

@Pipe({
  name: 'txt',
  pure: false,
  standalone: false,
})
export class TxtPipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;
  constructor(
    private txtService: TxtService,
    private ref: ChangeDetectorRef
  ) {
    this.asyncPipe = new AsyncPipe(ref);
  }

  transform(key: string): string | string[] {
    return this.asyncPipe.transform(this.txtService.getString(key));
  }

  ngOnDestroy() {
    this.asyncPipe.ngOnDestroy();
  }
}
